var $window, $body, $rangeSlider;
var mobileBreakpoint = 1175;
var prevScroll = 0;
var arrLeonardGTMTrackingFormPath = [
  "/fr/essai-gratuit/",
  "/fr/contact/",
  "/free-trial-subscription/",
  "/contact-us/",
];

$(function () { initialise(); });


function initialise() {
    $window = $(window);
    $body = $("body");
    $tableAddButton = $('.add_btn .add_icon');
    $tabSearchInput = $('.tab_input_search');
    $tabDeleteSearchBtn = $('.deleteBtn')
    $tableMinusButton = $('.minus_icon');
    $tableIdButton = $('.tab .id');
    $tableId = $('.tab id__img')
    $option = $('.filter');
    $tabFilter = $('.tabC th');
    $formManager = $('.form__choice');
    $fakeCheckbox = $('.fake-checkbox');
    $inputSearch = $('input[value="Search"');

    if ($window.width() > mobileBreakpoint) {
        sameHeight($('.big-menu .menu-title'));
    }
    sameHeight($('.content-boxes .image-top .title'));

    if ($window.width() < mobileBreakpoint) {
        $('.nav__list__item').toggleClass('meta_nav__list__item');
        $('.nav__list__item').toggleClass('nav__list__item');
        $('.menu-item-has-children').children('ul').hide();
        $('.sub-menu').toggleClass('sub-menu');

        var lnknew = $('.new_record').children('a');
        lnknew.removeAttr('class');
        lnknew.addClass('link principal');
        lnknew.text(lnknew.attr('label'));

        var lnkmyaccount = $('.myaccount').children('span').children('a');
        $('.myaccount .wrapper').replaceWith(lnkmyaccount);
        $('.myaccount').toggleClass('meta_nav__list__item');
        $('.myaccount').toggleClass('myaccount');
        lnkmyaccount.removeAttr('class');
        lnkmyaccount.addClass('link principal');
        lnkmyaccount.text(lnkmyaccount.attr('label'));

        var lnknavhistory = $('.nav_history').children('a');
        lnknavhistory.removeAttr('class');
        lnknavhistory.addClass('link principal');
        lnknavhistory.text(lnknavhistory.attr('label'));

        var navleftitems = $('.nav_left').children('ul').html();
        var navrightitems = $('.nav_right').children('ul').html();
        $('.nav_left').children('ul').html(navleftitems + navrightitems);
        $('.nav_right').hide();
    }

    $('.main-navigation > .menu-item-has-children').children('a').on('click', toggleSubMenu);
    $('.main-navigation .sub-menu > .menu-item-has-children').children('a').on('click', toggleSecondSubMenu);
    $('.mobile-btn').on('click', toggleMenu);
    $('.anchor-link').on('click', slideToAnchor);
    $tableAddButton.on('click', toggleTableOptions);
    $tableMinusButton.on('click', toggleTableOptions);
    $btnChangeNumber = $('.form .number').parent().find('.fa');

    // Add a delete button when input search is active
    $tabSearchInput.on('focus', function (e) {
        var selectedInput = $(e.currentTarget);
        if (!selectedInput.parent().children().hasClass('deleteBtn')) {
            selectedInput.parent().append('<svg class="deleteBtn" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"width="8.485px" height="8.485px" viewBox="0 0 8.485 8.485" enable-background="new 0 0 8.485 8.485" xml:space="preserve"><circle fill="#E60000" cx="4.243" cy="4.243" r="4.243"/><rect x="3.752" y="1.786" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.7573 4.2428)" fill="#FFFFFF" width="0.983" height="4.913"/><rect x="1.786" y="3.752" transform="matrix(0.707 -0.7073 0.7073 0.707 -1.7573 4.2441)" fill="#FFFFFF" width="4.914" height="0.981"/></svg>');
            $('.deleteBtn').on('click', cancelSearch);
        }

    });

    // When the delete btn is clicked in table search input
    function cancelSearch(e) {
        var deleteBtn = $(e.currentTarget);
        deleteBtn.siblings('input').val(' ');
        deleteBtn.remove();
    }

    // Deal with the value of input of type search
    $inputSearch.on('click', function (e) {
        var aimedInputSearch = $(e.currentTarget);
        aimedInputSearch.val(' ');
        $inputSearch.on('blur', function (e) {
            var aimedInputSearch = $(e.currentTarget);
            aimedInputSearch.val('Search');
        });
    });

    // Add calendar with datepicker plugin
    //  $('input.datepicker').Zebra_DatePicker();

    // Select right checkbox when the fake one is clicked
    $fakeCheckbox.on('click', function (e) {
    });

    $tabFilter.on('click', function (e) {
        filterSelected = $(e.currentTarget);
        $tabFilter.find('.filter').remove();

        if (filterSelected.hasClass('active')) {
            $tabFilter.removeClass('active');
            filterSelected.removeClass('active');
        }
        else {
            $tabFilter.removeClass('active');
            filterSelected.addClass('active');
            filterSelected.prepend('<svg class="filter" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"width="7.84px" height="7.871px" viewBox="0 0 7.84 7.871" enable-background="new 0 0 7.84 7.871" xml:space="preserve"><circle fill="#FC9611" cx="3.92" cy="3.936" r="3.92"/><polyline fill="none" stroke="#FFFFFF" stroke-linejoin="round" stroke-miterlimit="10" points="2.342,2.886 4.04,5.214 5.754,2.886 "/></svg>');
        }

    });

    // When the account button is click, open sub-menu
    $('.myaccount, .new_record, .nav_history').on('click', function (e) {
        var btnMyAccount = $('.myaccount');
        var btnNewRecord = $('.new_record');
        var btnNavHistory = $('.nav_history');

        if ($(e.currentTarget).hasClass('showsubmenu')) {
            $(e.currentTarget).removeClass('showsubmenu');
        }
        else {
            btnMyAccount.removeClass('showsubmenu');
            btnNewRecord.removeClass('showsubmenu');
            btnNavHistory.removeClass('showsubmenu');
            $(e.currentTarget).addClass('showsubmenu');
        }
    });

    $('.form__choice .select__list').change(function (e) {
        if ($formManager.hasClass('form__choice--active')) {
            $formManager.removeClass('form__choice--active');
        }
        else {
            $formManager.addClass('form__choice--active');
            $('.clear').addClass('show');
        }
    });

    // Give the table add button the proper row height
    /*$('table.datatable td:first-child').each(function(){
      var rowTableHeight = $(this).parent().height();
      $(this).height(rowTableHeight);
    });*/

    // When the clear button is click, reinitialise the form
    $('.clear').on('click', function () {
        $formManager.removeClass('form__choice--active')
        $('.clear').removeClass('show');
        $('.select__list option:first-child').attr('selected', 'selected')
    });

    // Increase/decrease number of required part
    $btnChangeNumber.on('click', function (e) {
        btn = $(e.currentTarget);
        var intVal = btn.parent().parent().find('.number').val();
        var intNewVal = parseFloat(intVal);
        if (btn.hasClass('fa-plus')) {
            intNewVal += 1;
            btn.parent().parent().find('.number').val(intNewVal)
        }
        else {
            if (intVal > 0) {
                intNewVal -= 1;
                btn.parent().parent().find('.number').val(intNewVal);
            }
        }

    });

    if ($('#auto-width').length > 0) {
        resizableInput(document.getElementById('auto-width'), 22);
    }

    var $lastSection = $('.main-content > section').last();
    if ($lastSection.hasClass('dark-bg')) {
        $('.main-content').addClass('bottom-border');
        $lastSection.addClass('last-section');
    }
    if ($('.tab')) {
        $('input[type="search"]');
    }

    if ('ontouchstart' in window ||
        navigator.msMaxTouchPoints ||
        navigator.userAgent.toLowerCase().match(/windows phone os 7/i)) {

        // ne pas suivre lien dans menu lorsque dropdown sur devices touch
        $('nav li > ul.sub-menu').each(function (index, elem) {
            $(elem).prev('a').click(function (event) {
                event.preventDefault();
            });
        });
    }
}

// ---------------------------------------
// ---------------------------------------
// Helpers
// ---------------------------------------
// ---------------------------------------

// Check if the body has a class(es)
//
// @return Boolean
function is_page(body_classes) {
  return $body.hasClass(body_class);
}


// Init same-height for a batch of element
//
// @return Void
function sameHeight($objects, startAt, endAt, heightType, callback) {
  startAt = typeof startAt == "undefined" ? 99999 : startAt;
  endAt = typeof endAt == "undefined" ? 0 : endAt;
  heightType = typeof heightType == "undefined" ? "height" : heightType;

  $window.on("resize", {cachedObjects: $objects, startAt: startAt, endAt: endAt, heightType: heightType, callback: callback}, function(e) {
    var $cachedObjects = e.data.cachedObjects;
    var startAt = e.data.startAt;
    var endAt = e.data.endAt;
    var heightType = e.data.heightType;
    var data_callback = "undefined";

    if($window.width() <= startAt && $window.width() >= endAt) {
      sameHeightSet($cachedObjects, heightType);
        data_callback= "enable";
    }else{
      $cachedObjects.css({minHeight: 0});
        data_callback = "disabled";
    }

    // Callback for extra works
    if(typeof e.data.callback !== "undefined") {
      e.data.callback(data_callback);
    }
  }).trigger("resize");
}

// Set same-height for a batch of cached elements
//
// @return Void
function sameHeightSet($cachedObjects, heightType) {
  var max = -1;
  var h = 0;

  $cachedObjects.css({minHeight: 0});
  $cachedObjects.each(function() {
    h = heightType === "outerHeight" ? $(this).outerHeight() : $(this).height();
    max = h > max ? h : max;
  });

  $cachedObjects.css({minHeight: max});
}

function customSelectDropdownCalc(){
  $('.custom-select').each(function(e){
    var selectorHeight = $(this).find('.selector').innerHeight();
    var extraPadding = 18;

    if ($(this).data('dropdown-padding')) {
      extraPadding = $(this).data('dropdown-padding');
    }
    $(this).find('.dropdown').css('padding-top', selectorHeight+extraPadding);
  });
}


function toggleSubMenu(e){
    if ($(window).width() < mobileBreakpoint) {
        $(this).parent().toggleClass('sub-menu-open');
        $(this).siblings('ul').slideToggle();
        e.preventDefault();
  }
}

function toggleSecondSubMenu(e){
    if ($(window).width() < mobileBreakpoint) {
        $(this).parent().toggleClass('sub-menu-open');
        $(this).parent().children('.sub-menu').slideToggle();
        e.preventDefault();
    }
}

function toggleMenu(e){
    $('.mobile-btn').toggleClass('menu-content-open');
    $('header .hector-logo').toggleClass('menu-content-open');
    $('header .menu-container').toggleClass('menu-content-open');
    $('.main-content').toggleClass('menu-content-open');
    $('footer').toggleClass('menu-content-open');
    $('body, html').toggleClass('hide-vscroll');
    e.preventDefault();
}

function closeMenu(e){
  if ($(window).width() < mobileBreakpoint && $(this).hasClass('menu-content-open')) {
    toggleMenu(e);
    e.preventDefault();
  }
}

function changeScreenText(e){
  $('.circle').removeClass('active');
  $('.circle-screen-display .text').removeClass('active');
  $(this).addClass('active');
  $('.text-'+$(this).data('counter')).addClass('active');
}


function slideToAnchor(e) {
  var $anchor = $(e.currentTarget).attr("href");
  if ($anchor.lastIndexOf("/") >= 0){
    $anchor = $anchor.substr($anchor.lastIndexOf("/")+1);
  }

  var $offset = $($anchor).offset().top-185
  $('html,body').animate({
    scrollTop: $offset
  }, 500);
  e.preventDefault();
  return false;
}

function toggleTableOptions(e){
  btn = $(e.currentTarget);
  $tableMinusButton.hide();
  $tableAddButton.show();
  if(btn.hasClass('add_icon'))
  {
    btn.hide();
    $('.add__option').remove();
    btn.parent().find('.minus_icon').show();
    btn.parent().append('<div class="add__option"><button class="btn">Edit</button><button class="btn">Assign to user</button><button class="btn">Schedule return</button><button class="btn">Return stockroom</button><button class="btn">Retire</button><button class="btn">Lost</button><span class="triangle-down"></span></div>');
  }
  else
  {
    if(btn.hasClass('minus_icon'))
    {
      $('.add__option').remove();
      btn.hide();
      $tableAddButton.show();
    }
  } 

}

/* ==========================================================================
   Feature lock badge — <hector:featurelock> (Driver\Controls\FeatureLock.cs)
   Hovering a locked button fades the "Available with the {plan} plan" badge in, and leaving fades
   it back out over the same duration (durations live in _featurelock.scss).
   The badge stays on the side asked for by BadgeSide: Popper 2 (loaded globally by every master
   page) never moves it to another side, it only re-anchors it on that side — centred on the button
   while there is room, otherwise edge aligned with whichever side still has space.
   The badge is a DOM child of the wrapper, so jQuery's containment check suppresses mouseleave
   while the pointer travels from the button onto it, and it stays clickable during the fade out.
   Event delegation on document, so it survives UpdatePanel partial postbacks.
   ========================================================================== */
var featureLockOffset = 16;                 // gap between the button and the badge, keep in sync with _featurelock.scss
var featureLockBoundaryPadding = 8;
var featureLockFadeSafetyDelay = 3000;      // safety net only: the real signal is the transitionend
var featureLockPoppers = [];                // {el, popper}, pruned after partial postbacks

$(function () { initFeatureLocks(); });

function initFeatureLocks() {
    $(document)
        .off('mouseenter.featurelock mouseleave.featurelock', '.featurelock')
        .on('mouseenter.featurelock', '.featurelock', function () {
            showFeatureLockBadge($(this));
        })
        .on('mouseleave.featurelock', '.featurelock', function () {
            hideFeatureLockBadge($(this));
        });

    if (typeof Sys !== 'undefined' && Sys.WebForms && Sys.WebForms.PageRequestManager) {
        var prm = Sys.WebForms.PageRequestManager.getInstance();
        prm.remove_pageLoaded(pruneFeatureLockPoppers);
        prm.add_pageLoaded(pruneFeatureLockPoppers);
    }
}

function showFeatureLockBadge($lock) {
    featureLockEndFade($lock);

    var popper = getFeatureLockPopper($lock);
    if (popper) {
        // Re-arm the scroll/resize listeners and reposition before the fade starts.
        popper.setOptions({ placement: featureLockPlacement($lock), modifiers: featureLockModifiers($lock, true) });
        popper.forceUpdate();
    }

    $lock.removeClass('is-badge-fading').addClass('is-badge-visible');
}

function hideFeatureLockBadge($lock) {
    // is-badge-fading keeps the badge clickable while it fades, so the pointer can still reach the
    // pricing link after crossing the gap.
    $lock.removeClass('is-badge-visible').addClass('is-badge-fading');

    // Disarming Popper's scroll/resize listeners goes through setOptions, which schedules an async
    // update: doing it while the badge is still fading lets Popper rewrite the transform and makes it
    // twitch on the way out. Wait for the real end of the opacity transition rather than for a
    // duration copied from the stylesheet, with a timer as a safety net in case no transitionend ever
    // fires (nothing to animate, reduced motion, background tab...).
    var $badge = $lock.children('.featurelock__badge');
    $badge
        .off('transitionend.featurelock')
        .on('transitionend.featurelock', function (e) {
            if (e.target === $badge[0] && e.originalEvent.propertyName === 'opacity') featureLockEndFade($lock);
        });
    $lock.data('flTimer', setTimeout(function () { featureLockEndFade($lock); }, featureLockFadeSafetyDelay));
}

// Called both when the fade out completes and when a new hover interrupts it.
function featureLockEndFade($lock) {
    clearTimeout($lock.data('flTimer'));
    $lock.removeData('flTimer').removeClass('is-badge-fading');
    $lock.children('.featurelock__badge').off('transitionend.featurelock');

    var popper = $lock.data('flPopper');
    if (popper && !$lock.hasClass('is-badge-visible')) {
        popper.setOptions({ placement: featureLockPlacement($lock), modifiers: featureLockModifiers($lock, false) });
    }
}

function getFeatureLockPopper($lock) {
    var existing = $lock.data('flPopper');
    if (existing) return existing;

    // No Popper on this page: keep the pure CSS placement.
    if (typeof Popper === 'undefined' || !Popper.createPopper) return null;

    var badge = $lock.children('.featurelock__badge')[0];
    if (!badge) return null;

    // The reference is the wrapper, not the inner button: the badge is out of flow, so it does not
    // contribute to the wrapper's box and there is no feedback loop.
    var popper = Popper.createPopper($lock[0], badge, {
        placement: featureLockPlacement($lock),
        // 'fixed' escapes .body-container{overflow:hidden} and .content-container{overflow-x:hidden},
        // which would otherwise clip the badge. No ancestor has a transform, so this is safe.
        strategy: 'fixed',
        modifiers: featureLockModifiers($lock, false)
    });
    // createPopper's first update is async: force it now, otherwise the badge can flash for one
    // frame at the top left corner of the viewport (applyStyles seeds top: 0; left: 0).
    popper.forceUpdate();

    // Switches the CSS fallback placement off: a leftover right/bottom would fight Popper.
    $lock.data('flPopper', popper).addClass('featurelock--floating');
    featureLockPoppers.push({ el: $lock[0], popper: popper });
    return popper;
}

// setOptions({modifiers}) REPLACES the user modifier array, it does not merge by name, so the full
// list has to be handed over every time.
function featureLockModifiers($lock, listenersEnabled) {
    return [
        { name: 'offset', options: { offset: [0, featureLockOffset] } },
        // Fall back to the VARIATIONS of the requested side, never to another side: the badge stays
        // under the button and only changes what it is anchored on. Centred while there is room,
        // then right edges aligned when it would run past the right boundary, left edges aligned
        // when it would run past the left one.
        { name: 'flip', options: { fallbackPlacements: featureLockVariations(featureLockPlacement($lock)), padding: featureLockBoundaryPadding, boundary: featureLockBoundary($lock) } },
        // Last resort clamp for when even the aligned variation does not fit: it does nothing as long
        // as the chosen variation fits, so the edge alignment above stays exact.
        { name: 'preventOverflow', options: { padding: featureLockBoundaryPadding, mainAxis: true, altAxis: false, boundary: featureLockBoundary($lock) } },
        { name: 'eventListeners', enabled: listenersEnabled }
    ];
}

function featureLockPlacement($lock) {
    if ($lock.hasClass('featurelock--top')) return 'top';
    if ($lock.hasClass('featurelock--right')) return 'right';
    if ($lock.hasClass('featurelock--left')) return 'left';
    return 'bottom';
}

// Same side, opposite anchors. Popper keeps the first one that fits, so '-end' is tried before
// '-start': an overflow on the right is the common case next to a right aligned toolbar.
function featureLockVariations(placement) {
    return [placement + '-end', placement + '-start'];
}

// The badge must be measured against the page content area, not the window. With strategy: 'fixed'
// Popper drops every clipping ancestor (a fixed element escapes them), so its default boundary is
// the viewport: a badge spilling over the side menu overflows nothing and stays wrongly centred.
function featureLockBoundary($lock) {
    return $lock.closest('.content-container')[0] || 'clippingParents';
}

// A partial postback swaps the wrapper's HTML: destroy the instances left pointing at detached
// nodes, otherwise their scroll/resize listeners keep firing for a badge nobody can see.
function pruneFeatureLockPoppers() {
    featureLockPoppers = featureLockPoppers.filter(function (entry) {
        if (document.body.contains(entry.el)) return true;
        entry.popper.destroy();
        return false;
    });
}
